import { render, staticRenderFns } from "./ListadoGrupo.vue?vue&type=template&id=5fd74bcb"
import script from "./ListadoGrupo.vue?vue&type=script&lang=js"
export * from "./ListadoGrupo.vue?vue&type=script&lang=js"
import style0 from "./ListadoGrupo.vue?vue&type=style&index=0&id=5fd74bcb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports